import config from '../../config';

export default {
  url: `${config.api.baseURL}/accounts/:accountId/babies/:id`,
  options: {
    method: 'PATCH'
  },
  transformer(data) {
    return data;
  }
};
